import { JSX, useState } from 'react';
import { ChevronDown } from 'lucide-react';
import './faq-question.css';
interface FaqQuestionProps {
    question: string;
    answer: string | JSX.Element;
  }

export default function FaqQuestion({ question, answer }: FaqQuestionProps) {
    const [questionOpen, setQuestionOpen] = useState(false);
    return (
        <div className="panel button-panel" onClick={() => setQuestionOpen(!questionOpen)}>
            <h3 className="faq-question-container">
                <div className={`faq-question ${questionOpen ? 'open' : ''}`}>{question}</div>
                <ChevronDown className={`faq-icon ${questionOpen ? 'rotate' : ''}`} />
            </h3>
            <div className={`faq-answer ${questionOpen ? 'open' : ''}`}>
                {answer}
            </div>
        </div>
    )
}